// ----------------------------------------------------------------------------
// Section: Featured Collection
// ----------------------------------------------------------------------------
//
// This is a section that displays featured collection items and optional button
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------
import Swiper from 'swiper';
import { Navigation, Pagination, Scrollbar, A11y, Keyboard } from 'swiper/modules';
import 'snippets/card/card';
import 'snippets/icon/icon';
import 'snippets/swiper-controls/swiper-control';

// Style includes
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/a11y';
import 'swiper/css/keyboard';
import './_collection-list.scss';

// -------------------------------------
// Variables
// -------------------------------------
var CAROUSEL_SELECTOR = '.carousel--collection-list';
var CAROUSEL_CLASS = 'carousel--collection-list';
var CAROUSEL_SECTION_SELECTOR = '.collection-list';
var CAROUSEL_SECTION_CLASS = 'collection-list';
var CAROUSEL_PREV_BUTTON_SELECTOR = '.swiper-button-prev';
var CAROUSEL_NEXT_BUTTON_SELECTOR = '.swiper-button-next';
var CAROUSEL_PAGINATION_SELECTOR = '.swiper-pagination';

// -------------------------------------
// Hooks
// -------------------------------------
document.querySelectorAll(CAROUSEL_SECTION_SELECTOR).forEach((element, index) => {
  // Generate unique class for each collection list slider
  element.querySelector(CAROUSEL_SELECTOR).classList.add("".concat(CAROUSEL_CLASS, "-").concat(index));

  // Generate unique btn classes for slider arrows
  element.querySelector(CAROUSEL_PREV_BUTTON_SELECTOR).classList.add("".concat(CAROUSEL_SECTION_CLASS, "-btn-prev-").concat(index));
  element.querySelector(CAROUSEL_NEXT_BUTTON_SELECTOR).classList.add("".concat(CAROUSEL_SECTION_CLASS, "-btn-next-").concat(index));
  element.querySelector(CAROUSEL_PAGINATION_SELECTOR).classList.add("".concat(CAROUSEL_SECTION_CLASS, "-pagination-").concat(index));
  var swiper = new Swiper(".".concat(CAROUSEL_CLASS, "-").concat(index), {
    // Optional parameters
    modules: [Navigation, Pagination, Scrollbar, A11y, Keyboard],
    slidesPerView: 20,
    spaceBetween: 0,
    watchOverflow: true,
    // Do not turn into sliders if number of slides is less than slidesPerView.
    keyboard: true,
    observer: true,
    observeParents: true,
    a11y: {
      slideRole: null
    },
    breakpoints: {
      // when window width is >= 768px
      768: {
        slidesPerView: 3.1,
        spaceBetween: 16
      },
      1080: {
        slidesPerView: 4,
        spaceBetween: 16
      }
    },
    pagination: {
      el: "".concat(CAROUSEL_SECTION_SELECTOR, "-pagination-").concat(index),
      clickable: true,
      renderBullet: function renderBullet(bulletIndex, className) {
        var isActive = this.activeIndex === bulletIndex ? 'aria-current="true"' : '';
        return "<span type=\"button\" tabindex=\"0\" class=\"".concat(className, "\" ").concat(isActive, "></span>");
      }
    },
    navigation: {
      nextEl: "".concat(CAROUSEL_SECTION_SELECTOR, "-btn-next-").concat(index),
      prevEl: "".concat(CAROUSEL_SECTION_SELECTOR, "-btn-prev-").concat(index)
    },
    on: {
      init() {
        // to fix Lazy load issue on mobile device
        removeLazyFromVisibleSlides(this);
      },
      slideChange() {
        var bullets = element.querySelectorAll("".concat(CAROUSEL_SECTION_SELECTOR, "-pagination-").concat(index, " .swiper-pagination-bullet"));
        bullets.forEach((bullet, bulletIndex) => {
          if (bulletIndex === swiper.activeIndex) {
            bullet.setAttribute('aria-current', 'true');
          } else {
            bullet.removeAttribute('aria-current');
          }
        });
        removeLazyFromVisibleSlides(this);
      }
    }
  });

  // Move to corresponding slide when Enter is pressed into pagination bullet
  var paginationBullets = element.querySelectorAll("".concat(CAROUSEL_SECTION_SELECTOR, "-pagination-").concat(index, " .swiper-pagination-bullet"));
  paginationBullets.forEach((bullet, bulletIndex) => {
    bullet.addEventListener('keydown', e => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault(); // prevent scrolling for space
        swiper.slideTo(bulletIndex);
      }
    });
  });
});
function removeLazyFromVisibleSlides(swiperInstance) {
  swiperInstance.slides.forEach(slide => {
    var rect = slide.getBoundingClientRect();
    var inView = rect.left < window.innerWidth && rect.right > 0;
    if (inView) {
      var img = slide.querySelector('.card__collection-image[loading="lazy"]');
      if (img) {
        img.removeAttribute('loading');
      }
    }
  });
}